import styled from "styled-components";

import SAImg from "./img/expanded/icon_jobs_23.gif"
import PunsherImg from "./img/expanded/icon_jobs_24.gif"
import InsurgentImg from "./img/expanded/icon_jobs_4215.gif"
import NinjaImg from "./img/expanded/icon_jobs_25.gif"
import KagerouOboroImg from "./img/expanded/icon_jobs_4211.gif"
import TaekwonImg from "./img/expanded/icon_jobs_4046.gif"
import MasterTaekwonImg from "./img/expanded/icon_jobs_4047.gif"
import SpiritImg from "./img/expanded/icon_jobs_4048.gif"
import StarEmperorImg from "./img/expanded/icon_jobs_4239.gif"
import ReaperImg from "./img/expanded/icon_jobs_4240.gif"


function ExpandedQuests() {
    return(<>
            <ClassListContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={SAImg}/>
                    <ClassListDescription>Super Aprendiz</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>

            <ClassListContainer>
                <TitleContainer>Justiceiro</TitleContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={PunsherImg}/>
                    <ClassListDescription>Justiceiro</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={InsurgentImg}/>
                    <ClassListDescription>Insurgente</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>

            <ClassListContainer>
                <TitleContainer>Ninja</TitleContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={NinjaImg}/>
                    <ClassListDescription>Ninja</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={KagerouOboroImg}/>
                    <ClassListDescription>Kagerou</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={KagerouOboroImg}/>
                    <ClassListDescription>Oboro</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>

            <ClassListContainer>
                <TitleContainer>Taekwon</TitleContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={TaekwonImg}/>
                    <ClassListDescription>Taekwon</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={MasterTaekwonImg}/>
                    <ClassListDescription>Mestre Taekwon</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={SpiritImg}/>
                    <ClassListDescription>Espiritualista</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>

            <ClassListContainer>
                <TitleContainer>Evolução Taekwon</TitleContainer>
                <ClassListItem>
                    <ClassListIcon iconImage={StarEmperorImg}/>
                    <ClassListDescription>Imperador Estelar</ClassListDescription>
                </ClassListItem>
                <ClassListItem>
                    <ClassListIcon iconImage={ReaperImg}/>
                    <ClassListDescription>Seifador de Almas</ClassListDescription>
                </ClassListItem>
            </ClassListContainer>
        </>
    )
}

const TitleContainer = styled.h1`

`

const ClassListContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 300px;
    margin: 30px 0;
`

const ClassListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    width: 250px;
    padding: 8px;
    margin: 2px 0;
    transition: .2s ease-in-out;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer; 
     }

    &:hover {
        background-color: rgba(25, 131, 69, 1);
        color: white;
        scale: 1.2;
    }
`

const ClassListIcon = styled.div`
    background-image: url(${props => props.iconImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 25px;
    height: 25px;
    //border: solid 1px rgba(0,0,0,1)
`

const ClassListDescription = styled.span`
    width: 200px;
    height: 25px;
`



export default ExpandedQuests;